
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.539 15.81c-1.094-.028-1.996-.526-2.572-1.566-.59-1.076-.565-2.176.065-3.225 1.498-2.496 3.017-4.978 4.526-7.466.308-.509.61-1.025.933-1.524A3.027 3.027 0 0117.358.682a2.942 2.942 0 012.247.38 3.143 3.143 0 011.011 4.268 632.817 632.817 0 01-5.502 9.082c-.573.931-1.442 1.38-2.575 1.398z","fill":"#FFCB00"}}),_c('path',{attrs:{"d":"M3.147 15.81c-1.103-.028-2-.549-2.565-1.584C0 13.15.037 12.047.668 10.999 2.28 8.327 3.9 5.659 5.526 2.995c.206-.344.412-.697.632-1.03A3.02 3.02 0 018.056.675a2.946 2.946 0 012.231.438c.66.44 1.13 1.128 1.307 1.92.178.79.051 1.621-.354 2.317-1.802 3.005-3.629 6-5.456 8.992-.594.97-1.467 1.45-2.637 1.468z","fill":"#FF3D57"}}),_c('path',{attrs:{"d":"M21.99 9.718c1.664.008 3.01 1.373 3.007 3.048 0 1.7-1.383 3.07-3.061 3.05a3.028 3.028 0 01-3-3.055 3.019 3.019 0 013.054-3.043z","fill":"#00D647"}})])
          )
        }
      }
    